<template>
  <div class="app">
    <scroll>
      <ul class="user-info">
        <li>
          <span class="left">医院</span>
          <span class="right">{{ hospitalName }}</span>
        </li>
        <li>
          <span class="left">科室</span>
          <span class="right">{{ deptName }}</span>
        </li>
        <li>
          <span class="left">医生</span>
          <span class="right">{{ doctName }}</span>
        </li>
        <li>
          <span class="left">姓名</span>
          <span class="right">{{ userName }}</span>
        </li>
        <li>
          <span class="left">卡号</span>
          <span class="right">居民健康卡{{ cardNo | dotted }}</span>
        </li>
        <li>
          <span class="left">门诊号</span>
          <span class="right">{{ visitId }}</span>
        </li>
        <li>
          <span class="left">开单时间</span>
          <span class="right">{{ makeTime }}</span>
        </li>
        <li>
          <span class="left">门诊诊断</span>
          <span class="right">{{ diagnosis }}</span>
        </li>
      </ul>
      <section class="thick" style="margin-top: 0.5rem">
        <ul class="tab-top">
          <li
            @click="onSelectedTab(index)"
            v-for="(item, index) in tabs"
            class="tab-item"
            :id="'register-departDoctor-tab-' + item.tabId"
            :class="{ active: selectedTab.tabId == item.tabId }"
          >
            <span class="tab-label">{{ item.tabName }}</span>
          </li>
        </ul>
      </section>
      <div
        v-for="(item, index) in medicalInfo"
        v-if="item.recipeType == selectedTab.tabId"
      >
        <ul class="recipe-list">
          <li>
            <span
              class="left"
              style="color: #54a9ec"
              v-if="selectedTab.tabId == '3'"
              >处方号:&nbsp;&nbsp;{{ item.recipeId }}</span
            >
            <span
              class="left"
              style="color: #54a9ec"
              v-if="selectedTab.tabId !== '3'"
              >{{ item.recipeName }}</span
            >
            <span class="right" style="color: #fe0202">{{
              item.recipeFee | formatFee
            }}</span>
          </li>
          <ul
            class="project-list"
            style="font-size: 13px"
            v-for="(project, index) in item.items"
            v-if="selectedTab.tabId == '3'"
          >
            <li>
              <span
                >{{ project.itemName }}&nbsp;
                <span class="project-title" v-if="project.specs != ''"
                  >({{ project.specs }})</span
                >
              </span>
            </li>
            <li>
              <div>
                <span
                  ><span class="color-gray">单价:&nbsp;&nbsp;</span
                  >{{ project.price | formatFee(false) }}</span
                >
              </div>
              <div>
                <span
                  ><span class="color-gray">数量:&nbsp;&nbsp;</span
                  >{{ project.qty }}{{ project.unit }}</span
                >
              </div>
            </li>
            <li>
              <span
                ><span class="color-gray">使用方法：&nbsp;&nbsp;</span
                >{{ project.instructions }}</span
              >
            </li>
            <li>
              <span
                ><span class="color-gray">厂商：&nbsp;&nbsp;</span
                >{{ project.factory }}</span
              >
            </li>
          </ul>
          <ul
            class="project-list"
            style="font-size: 13px"
            v-if="selectedTab.tabId == '3'"
          >
            <li>
              <span class="color-gray">医生&nbsp;(审核、核对、发药)</span>
              <span>{{ item.checkDoctor }}</span>
            </li>
            <li>
              <span class="color-gray">药师/士&nbsp;(调配)</span>
              <span>{{ item.execDoctor }}</span>
            </li>
            <li>
              <span class="color-gray">取药窗口</span>
              <span>{{ item.location }}</span>
            </li>
          </ul>
          <ul
            class="project-list"
            style="font-size: 13px"
            v-for="(project, index) in item.items"
            v-if="selectedTab.tabId !== '3'"
          >
            <li>
              <span
                >{{ project.itemName }}&nbsp;
                <span class="project-title" v-if="project.specs != ''"
                  >({{ project.specs }})</span
                >
              </span>
            </li>
            <li>
              <div>
                <span
                  ><span class="color-gray">单价:&nbsp;&nbsp;</span
                  >{{ project.price | formatFee(false) }}</span
                >
              </div>
              <div>
                <span
                  ><span class="color-gray">数量:&nbsp;&nbsp;</span
                  >{{ project.qty }}{{ project.unit }}</span
                >
              </div>
            </li>
          </ul>
        </ul>
      </div>
      <no-record
        id="myregister-norecord"
        :condition="medicalInfo | dataFilter(selectedTab.tabId)"
        tips="抱歉，没有处方记录"
      ></no-record>
      <div
        class="footer"
        v-if="
          selectedTab.tabId == '3' &&
          dataFilter(medicalInfo, selectedTab.tabId).length != 0
        "
      >
        <div><span class="color-blue">提示信息:</span></div>
        <span class="color-gray"
          >按卫生部、国家中医药管理局卫医发[2002]24号文件规定:为保证患者用药安全，药品已经发出，不得退换。</span
        >
      </div>
    </scroll>
  </div>
</template>

<script>
import NoRecord from 'NoRecord'
export default {
  components: {
    NoRecord,
  },
  data () {
    return {
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      tabs: [{
        tabName: '检查项',
        tabId: '1',
      }, {
        tabName: '检验项',
        tabId: '2',
      }, {
        tabName: '药品项',
        tabId: '3',
      }],
      selectedTab: {
        tabId: '1'
      },
      hospitalName: '',
      visitId: '',
      deptName: '',
      userName: '',
      doctName: '',
      cardNo: '',
      totalFee: '',
      diagnosis: '',
      makeTime: '',
      medicalInfo: []
    }
  },
  mounted () {
    let userInfo = JSON.parse(localStorage.getItem('deptList'))
    let recipes = JSON.parse(localStorage.getItem('deptList')).recipes
    this.medicalInfo = recipes
    this.deptName = userInfo.deptName
    this.doctName = userInfo.doctName
    this.visitId = userInfo.visitId
    this.diagnosis = userInfo.diagnosis
    this.makeTime = this.$route.query.makeTime
    this.userName = this.$route.query.holderName
    this.hospitalName = this.$route.query.hospitalName
    this.cardNo = this.$route.query.cardNo
  },
  methods: {
    refresh () {

    },
    onSelectedTab (index) {
      this.selectedTab.tabId = this.tabs[index].tabId
    },
    dataFilter (data, tabId) {
      for (var i = 0; i < data.length; i++) {
        if (tabId == data[i].recipeType) {
          return data
        }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background-color: #eff3f6;
  .color-blue {
    color: #52a8ed;
  }
  .color-gray {
    color: #b6b6b6;
  }
  .color-red {
    color: #fe0202;
  }
  .user-info {
    margin: 0.3rem 0;
    background-color: #fff;
    li {
      height: 1rem;
      line-height: 1rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.85rem;
      border-bottom: 0.05rem solid #f0f1f5;
      &:last-child {
        border: none;
      }
      .left {
        color: #a2a2a2;
      }
    }
  }
  .recipe-list {
    li {
      background-color: #fff;
      height: 1rem;
      line-height: 1rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.85rem;
      &:last-child {
        border: none;
      }
      .left {
        color: #a2a2a2;
      }
    }
    .project-list {
      margin: 0.4rem 0;
      background-color: #fff;
      li {
        height: 1rem;
        line-height: 1rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.05rem solid #f0f1f5;
        .project-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      div {
        flex: 1;
        border-right: 0.025rem solid #f0f1f5;
        &:nth-child(2) {
          padding-left: 0.5rem;
          border-right: none;
        }
      }
    }
  }
  .footer {
    font-size: 13px;
    padding: 0 0.75rem;
  }
}
</style>


// WEBPACK FOOTER //
// PrescriptionDetail.vue?797a0ad7